export default {
  "b2b.app-footer.phone": "phone",
  "b2b.app-footer.ic": "VAT",
  "b2b.app-footer.registration":
    "Registered in the Commercial Register maintained by the Municipal Court in Prague, Section B, File 10025",
  "b2b.app-footer.rights": "Všechna práva vyhrazena.",
  "b2b.app-footer.cookiesPrinciples": "PRINCIPLES OF USING COOKIES",
  "b2b.app-footer.cookiesSettings": "COOKIE SETTINGS",
  "b2b.app-footer.privacy": "PRIVACY POLICY"
};
